import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=484bdfa8&scoped=true"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=484bdfa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484bdfa8",
  null
  
)

export default component.exports